<app-colored-background [backgroundColor]="'#03A97F'">
  <div style="height: 86px;" data-testid="overview-finished-spacer"></div>
  <div data-testid="overview-finished-container">
    <div class="base-content-container" data-testid="overview-finished-content">
      <div class=headline1 style="color: #FFFFFF" data-testid="overview-finished-headline">
        {{ locale.currentTranslation.finishHeadline }}
      </div>
      <div class="text-body1" style="color: #FFFFFF" data-testid="overview-finished-text">
        {{ locale.currentTranslation.finish1 }}
        <div data-testid="overview-finished-text-2">
          {{locale.currentTranslation.finish2}}
        </div>
      </div>
    </div>
    <app-finish-box data-testid="overview-finished-finish-box"></app-finish-box>
    <div class="main-button-spacing" data-testid="overview-finished-button-container">
      <button class="main-button" routerLink="/" data-testid="btn-to-start" role="button" tabindex="0">{{ locale.currentTranslation.toStart }}</button>
    </div>
  </div>

  <app-footer data-testid="overview-finished-footer"></app-footer>
</app-colored-background>
